export default "__VITE_ASSET__DMo24dN1__"